(() => {
  const dialog = document.querySelector('.aq-search-dialog');
  if (!dialog) return;
  const input = dialog.querySelector('input[name="q"]');
  const results = dialog.querySelector('#AqSearchResults');
  const initial = results.innerHTML;
  const status = dialog.querySelector('[data-aq-search-status]');
  let timer, controller, version = 0, previous, suppressOpen = false;
  const all = () => { const url = new URL(dialog.dataset.allUrl, location.origin); const preview = new URLSearchParams(location.search).get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview); location.assign(url); };
  if (location.pathname.replace(/\/$/, '') === dialog.dataset.searchUrl.replace(/\/$/, '') && !(new URLSearchParams(location.search).get('q') || '').trim()) { all(); return; }
  const update = () => {
    clearTimeout(timer); controller?.abort(); const current = ++version;
    const query = input.value.trim();
    if (!query) { results.innerHTML = initial; status.textContent = ''; return; }
    status.textContent = 'Loading suggestions';
    timer = setTimeout(async () => {
      controller = new AbortController();
      const url = new URL(dialog.dataset.suggestUrl, location.origin);
      url.search = new URLSearchParams({q:query, 'resources[type]':'product,collection', 'resources[limit]':'4', section_id:'aq-predictive-search'});
      try {
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-aq-predictions]');
        if (current !== version) return;
        if (!html) throw new Error('No suggestions');
        results.replaceChildren(html); status.textContent = 'Suggestions updated';
      } catch (error) {
        if (error.name === 'AbortError' || current !== version) return;
        results.replaceChildren(); const link = document.createElement('a');
        link.href = dialog.dataset.searchUrl + '?' + new URLSearchParams({q:query,type:'product'});
        link.textContent = 'Search all products for “' + query + '”'; results.append(link);
        status.textContent = 'Suggestions are unavailable. You can still search all products.';
      }
    }, 250);
  };
  const openFromHeader = event => {
    if (suppressOpen || !event.target.matches('.aq-header-search input')) return;
    previous = event.target; input.value = previous.value;
    if (!dialog.open) dialog.showModal(); input.focus(); update();
  };
  document.addEventListener('pointerdown', event => { if (event.target.matches('.aq-header-search input')) suppressOpen = false; });
  document.addEventListener('keydown', event => { if (event.key === 'Tab') suppressOpen = false; if (event.key === 'Escape' && dialog.open) { event.preventDefault(); close(); } });
  document.addEventListener('focusin', openFromHeader);
  document.addEventListener('click', openFromHeader);
  if (document.activeElement?.matches('.aq-header-search input')) openFromHeader({target:document.activeElement});
  const close = () => { suppressOpen = true; dialog.close();  };
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => { clearTimeout(timer); controller?.abort(); version++; previous?.blur(); });
  dialog.querySelector('[data-aq-search-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => { const term = event.target.closest('[data-aq-search-term]'); if (term) { event.preventDefault(); input.value = term.dataset.aqSearchTerm; input.focus(); update(); } });
  input.addEventListener('input', update);
  document.addEventListener('submit', event => { const form = event.target; if (new URL(form.action, location.origin).pathname !== dialog.dataset.searchUrl) return; const q = form.querySelector('[name="q"]'); if (q && !q.value.trim()) { event.preventDefault(); all(); } }, true);
})();
